import { useState } from 'react';
import apiService from '../services/api';

const Login = ({ onLoginSuccess }) => {
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      let data;
      if (mode === 'register') {
        data = await apiService.register(email, username, password, fullName);
      } else {
        data = await apiService.login(email, password);
      }

      if (data?.access_token) {
        localStorage.setItem('access_token', data.access_token);
        if (data.refresh_token) localStorage.setItem('refresh_token', data.refresh_token);
        if (data.user) localStorage.setItem('af_user', JSON.stringify(data.user));
        onLoginSuccess(data.user);
      } else {
        setError('Authentication failed — no token received');
      }
    } catch (err) {
      setError(err.message || (mode === 'register' ? 'Registration failed' : 'Invalid email or password'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="af-shell"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '2rem 1rem' }}
    >
      <div className="af-panel" style={{ width: '100%', maxWidth: '420px', padding: '2.5rem 2rem', display: 'flex', flexDirection: 'column', gap: '1.75rem' }}>
        <div style={{ textAlign: 'center' }}>
          <div className="af-text-accent" style={{ fontSize: '1.5rem', fontWeight: 700, letterSpacing: '0.15em', marginBottom: '0.4rem' }}>
            [ AI FLOW ]
          </div>
          <div className="af-text-muted" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
            7h3.agency · visual AI workflow builder
          </div>
        </div>

        <div className="af-divider" />

        {/* Mode tabs */}
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {['login', 'register'].map(m => (
            <button
              key={m}
              type="button"
              onClick={() => { setMode(m); setError(''); }}
              className={m === mode ? 'af-btn af-btn-primary' : 'af-btn'}
              style={{ flex: 1, fontSize: '0.75rem', letterSpacing: '0.08em' }}
            >
              {m === 'login' ? 'SIGN IN' : 'CREATE ACCOUNT'}
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          {mode === 'register' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
              <label htmlFor="full-name" className="af-label">Full Name</label>
              <input
                id="full-name"
                type="text"
                className="af-input"
                placeholder="Your name"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
              />
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            <label htmlFor="email-address" className="af-label">Email Address</label>
            <input
              id="email-address"
              type="email"
              autoComplete="email"
              required
              className="af-input"
              placeholder="user@domain.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          {mode === 'register' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
              <label htmlFor="username" className="af-label">Username</label>
              <input
                id="username"
                type="text"
                autoComplete="username"
                required
                className="af-input"
                placeholder="your_handle"
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
              <div className="af-text-muted" style={{ fontSize: '0.68rem' }}>
                Letters, numbers, _ and - only. Spaces and special characters will be removed.
              </div>
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            <label htmlFor="password" className="af-label">Password</label>
            <input
              id="password"
              type="password"
              autoComplete={mode === 'register' ? 'new-password' : 'current-password'}
              required
              className="af-input"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <div style={{ color: '#ff4e7a', fontSize: '0.8rem', textAlign: 'center', letterSpacing: '0.04em' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="af-btn af-btn-primary"
            style={{ width: '100%', opacity: loading ? 0.55 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? (mode === 'register' ? 'CREATING ACCOUNT...' : 'AUTHENTICATING...') : (mode === 'register' ? 'CREATE PRO ACCOUNT' : 'AUTHENTICATE')}
          </button>
        </form>

        <div className="af-divider" />

        <div className="af-text-muted" style={{ fontSize: '0.72rem', textAlign: 'center', letterSpacing: '0.04em' }}>
          {mode === 'register' ? 'All accounts include Pro access · no credit card required' : 'New? Switch to Create Account above'}
        </div>
      </div>
    </div>
  );
};

export default Login;
